//enum for report type
export const ReportType = Object.freeze({
  ANALYTIC: "analytic",
  GENERATIVE: "generative",
});
